import { inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppSettingsService } from './core/services/app-settings.service';
declare var google: any;

export function initializeApp() {
  const appSettingsService = inject(AppSettingsService);
  const titleService = inject(Title);

  return () =>
    new Promise((resolve, reject) => {
      // Load settings first
      appSettingsService.loadSettings().subscribe({
        next: async (settings) => {
          // Set the initial page title
          titleService.setTitle(settings.appTitle);

          // Load Google Maps script dynamically and wait for completion
          await loadGoogleMapsScript(settings.googleMapsApiKey);
          resolve(null);
        },
        error: async (error) => {
          console.error('Failed to load app settings:', error);
          resolve(null);
        },
      });
    }).then(() => {
      console.log('App initialization completed');
    });
}

function loadGoogleMapsScript(apiKey: string): Promise<void> {
  return new Promise((resolve, reject) => {
    // Check if Google Maps is already loaded
    if (typeof google !== 'undefined' && google.maps) {
      resolve();
      return;
    }

    // Check if script is already in DOM
    const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
    if (existingScript) {
      // Script exists, wait for it to load
      existingScript.addEventListener('load', () => resolve());
      existingScript.addEventListener('error', reject);
      return;
    }

    // Create and load new script
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`;
    script.async = true;
    script.defer = true;

    script.addEventListener('load', () => {
      console.log('Google Maps script loaded successfully');
      resolve();
    });

    script.addEventListener('error', (error) => {
      console.error('Failed to load Google Maps script:', error);
      reject(error);
    });

    document.head.appendChild(script);
  });
}
